module.exports = __webpack_public_path__ + "img/public_3.d3b683b5.jpg";